import React from 'react';
import PropTypes from 'prop-types';

// - Components
import Typography from '@material-ui/core/Typography';

import StandAloneIcon from 'components/Icons/StandAlone';
import CategoryIcon from 'components/Icons/ProfileLayout/CategoryIcon';

import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
    cursor: 'pointer',
  },
  images: {
    width: 115.47,
    height: 63,
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    marginTop: theme.spacing(1.25),
  },
});

class DialogSelectItem extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    img: PropTypes.string.isRequired,
    handleSwitch: PropTypes.func.isRequired,
  };

  components = {
    standAlone: StandAloneIcon,
    category: CategoryIcon,
  };

  handleClick = () => {
    this.props.handleSwitch(this.props.title);
  };

  render() {
    const { classes } = this.props;
    const Image = this.components[this.props.img];
    return (
      <div onClick={this.handleClick} className={classes.root}>
        <Image className={classes.images} />
        <Typography variant="h6">{this.props.title}</Typography>
        <Typography variant="body2" className={classes.subtitle}>
          {this.props.subtitle}
        </Typography>
      </div>
    );
  }
}

export default withStyles(styles)(DialogSelectItem);
